import React from 'react';
import { IconButton, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";
import CustomButton from "../../components/buttons/CustomButton";
import styles from "./popup.module.css";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        color: "#fff",
        textAlign: "center",
        padding: "5px",
        fontSize: "12px",
        fontWeight: 600,
        borderTop: "1px solid #EAECF0",
        // borderRight: "1px solid #EAECF0",
        borderBottom: "1px solid #EAECF0",
        borderLeft: "1px solid #EAECF0",
        whiteSpace: "nowrap",
    },
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: "12px",
        fontWeight: 400,
        padding: "5px",
        color: "#2B2B2B",
        borderTop: "1px solid #EAECF0",
        // borderRight: "1px solid #EAECF0",
        borderBottom: "1px solid #EAECF0",
        // borderLeft: "1px solid #EAECF0",
        textAlign: "center",
        whiteSpace: "nowrap",
    },
}));

const StyledTableRow = styled(TableRow)({
    backgroundColor: "#FFFFFF !important"
});

const PODetailsMAI = ({ type, tableData, handleAlertPopup, rowData }) => {
    return (
        <Modal open={Boolean(type)} onClose={handleAlertPopup}>
            <div className={styles.modalContainer}>
                <div className={styles.dialogBox} style={{ width: "95%", height: "90%" }}>
                    {typeof tableData === 'string' || tableData.length === 0 ? (
                        <Typography className={styles.subHeader} sx={{ textAlign: 'center', marginTop: '10px' }}>
                            {`No PO details available for this ${rowData["Site code"]} site & ${rowData["Material Id"]} material.`}
                        </Typography>
                    ) : (
                        <TableContainer className={styles.table} style={{maxHeight:'fit-content'}}>
                            <Table size="small" >
                                <TableHead sx={{ position: 'sticky', top: 0, zIndex: 999 }}>
                                    <TableRow sx={{ backgroundColor: "var(--primany-table-header-color)" }}>
                                        {Object.keys(tableData[0]).map((col, index) => (
                                            <StyledTableCell key={Math.random() * index}>
                                                <div>{col}</div>
                                            </StyledTableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableData.map((row, rowIndex) => (
                                        <StyledTableRow key={Math.random() * rowIndex}>
                                            {Object.keys(row).map((col, colIndex) => (
                                                <StyledTableCell key={Math.random() * colIndex} sx={{ border: "1px solid #EAECF0" }}>
                                                    <div>{row[col]}</div>
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                    <div className={`${styles.dialogBtn} ${styles.cancelBtn}`}>
                        <CustomButton label="Close" type="reject" onClick={handleAlertPopup} />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default PODetailsMAI;